import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import IconButtonTsoPq from '@components/Buttons/IconButtonTsoPq';
import { Box, FormControl, FormControlLabel, FormGroup, FormLabel, styled } from '@mui/material';

export const StyledContentWrapper = styled(Box)(() => {
  return {
    width: '100%',
    paddingTop: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
  };
});

export const StyledContent = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  };
});
export const StyledContentTitle = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledHeaderContainer = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledCheckboxControlsContainer = styled(FormControl)(() => {
  return {
    width: '100%',
    maxWidth: '32rem',
  };
});

export const StyledCheckboxControlsLabel = styled(FormLabel)(() => {
  return {
    display: 'flex',
    color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    fontSize: tsoPqTheme.typography.fontsize_body_body_small,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '1rem',
    padding: '0 0 0 0.25rem',
    '&.Mui-focused': {
      color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    },
    '&.MuiFormLabel-root.Mui-focused': {
      color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
    },
  };
});

export const StyledCheckboxControlsWrapper = styled(FormGroup)(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  };
});

export const StyledCheckboxOptionWrapper = styled(FormControlLabel)(() => {
  return {
    marginLeft: '0.075rem',
    minWidth: '14.035rem',
  };
});

export const StyledLabel = styled('span')({
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  textAlign: 'center',
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: tsoPqTheme.typography.fontsize_label_label_medium,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: tsoPqTheme.typography.lineHeight_m,
  letterSpacing: '0.007rem',
});

export const StyledDisabledLabel = styled('span')({
  color: tsoPqTheme.palette.customTextColor.color_font_ft_nrtrl_disabled,
  textAlign: 'center',
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: tsoPqTheme.typography.fontsize_label_label_medium,
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: tsoPqTheme.typography.lineHeight_m,
  letterSpacing: '0.007rem',
});
// styling of the boxplot

export const StyledBoxplotWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
    padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_24,
    backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
  };
});

export const StyledBoxplotTtileLine = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledBoxplotTtileSection = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledBoxplotSwitchComponent = styled(Box)(() => {
  return {
    display: 'flex',
  };
});

export const StyledBoxplotContainer = styled(Box)(() => {
  return {
    display: 'flex',
    width: '100%',
    height: '24rem',
    flexGrow: 1,
    minWidth: 0,
  };
});

export const StyledBoxplotSwitchLabel = styled(FormControlLabel)(() => {
  return {
    fontFamily: tsoPqTheme.typography.openSans,
    fontSize: tsoPqTheme.typography.fontsize_body_body_medium,
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledIconButtonTsoPq = styled(IconButtonTsoPq)(() => {
  return {
    alignSelf: 'flex-end',
  };
});
